import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './actorsHandler.module.scss';
import OrgChart from './orgChart';
import ClientOrgChart from './clientOrgChart';
import Dialog from './../../../UiComponents/Dialog';
import getLabel from './../../../../utils/labels'
import actorClose from '../../../../globals/images/actor-close.svg'
import addPeopleIcon from '../../../../globals/images/add-people.png';

class ActorsHandler extends Component {
    constructor(props) {
        super(props);
        let tempArray = [];
        if (props.selectedActors) {
            tempArray = props.selectedActors
        }
        this.state = {
            displayScrollInfo: false,
            isOrgChartOpen: false,
            selectedActors: tempArray,
            tempActorArray: tempArray
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.isScrollVisible, true);
    }

    componentDidUpdate() {
        this.isScrollVisible();
    }

    checkIfOptionPresentInArray = (array, element) => {
        return array.includes(element);
    }

    isScrollVisible = () => {
        let boxSize = window.innerHeight * 0.925 - 40;
        const node = ReactDOM.findDOMNode(this.orgChartDiv);
        if (node) {
            let rect = node.getBoundingClientRect();
            let elemBottom = rect.bottom;
            if (elemBottom <= boxSize) {
                if (this.state.displayScrollInfo) {
                    this.setState({ displayScrollInfo: false })
                }
            } else {
                if (!this.state.displayScrollInfo) {
                    this.setState({ displayScrollInfo: true })
                }
            }

        }
    }

    onRemoveActorClick = (id) => {
        this.setState(prevState => ({
            selectedActors: prevState.selectedActors.filter(x => x !== id)
        }),
            () => {
                const { saveToActors, saveCcActors, type } = this.props;
                const { selectedActors } = this.state;
                if (type === 'to') {
                    saveToActors(selectedActors)
                } else {
                    saveCcActors(selectedActors)
                }
            });
    }

    onOptionClick = (id) => {
        const { actors } = this.props;
        const { selectedActors } = this.state;

        if (this.props.tutorial.isRunning) {
            this.goToNextTutorialStep()
        }

        if (!this.checkIfOptionPresentInArray(selectedActors, id)) {
            this.setState(prevState => ({
                selectedActors: [...prevState.selectedActors, id]
            }));
        } else {
            this.setState(prevState => ({
                selectedActors: prevState.selectedActors.filter(x => x !== id)
            }));
        }
    }

    clearSelectedActors = () => {
        this.setState(prevState => ({
            selectedActors: prevState.tempActorArray
        }));
        this.closeOrgChart();

        if (this.props.tutorial.isRunning) {
            this.goToNextTutorialStep();
        }
    }

    updateData = () => {
        this.closeOrgChart();

        this.setState({
            tempActorArray: this.state.selectedActors
        })

        if (this.props.tutorial.isRunning) {
            this.goToNextTutorialStep();
        }
    }

    openOrgChart = () => {
        this.setState({
            isOrgChartOpen: true
        })
        if (this.props.tutorial.isRunning) {
            this.props.stopTutorial();
            setTimeout(() => {
                this.goToNextTutorialStep();
                this.props.startTutorial();
            }, 1500);
        }
    }

    goToNextTutorialStep = () => {
        this.props.updateStepNumber(this.props.tutorial.stepIndex + 1);
    }

    closeOrgChart = () => {
        const { saveToActors, saveCcActors, type } = this.props;
        const { selectedActors } = this.state;
        if (type === 'to') {
            saveToActors(selectedActors)
        } else {
            saveCcActors(selectedActors)
        }
        this.setState({
            isOrgChartOpen: false
        })
    }

    getSelectedActors = (selectedActors) => {
        const { actors } = this.props;
        let currentActor = null;
        return <div style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '1000px' }}>
            {
                selectedActors.map((selectedActor, key) => {
                    currentActor = actors.clients.find(actor => actor.id === selectedActor) || actors.inActors.find(actor => actor.id === selectedActor);

                    return <div key={key} className={styles.actor} onClick={() => { this.onRemoveActorClick(selectedActor) }}>
                        <div className={styles.name}>{`${currentActor.first_name} ${currentActor.last_name}`}</div>
                        <img src={actorClose} />
                    </div>
                })
            }
        </div>
    }

    render() {
        let { isOrgChartOpen, selectedActors, tempActorArray, displayScrollInfo } = this.state;
        let isCloseButtonNeeded = true;
        let tutorialStep;
        tutorialStep = this.props.type === "to" ? "tutorial-add-people" : null

        return (
            <Fragment >
                {
                    selectedActors ?
                        this.getSelectedActors(selectedActors)
                        : null
                }
                <div id={tutorialStep} className={styles['button-holder']}  >
                    <div onClick={this.openOrgChart} className={styles['select-button']}>
                        <div className={styles['add-message-button']}>
                            <img src={addPeopleIcon} className={styles['add-message-icon']} />
                        </div>
                        <div className={styles['add-message-text']}>{getLabel('label_add_people_button')}</div>
                    </div>
                </div>
                {
                    this.props.isFirstMail ?
                        <div className={styles.warning}>
                            {getLabel('label_add_people_info')}
                        </div>
                        :
                        null
                }
                {
                    isOrgChartOpen ?
                        <Dialog
                            title={getLabel('label_select_people_text')}
                            overlayClassName={styles.dialog}
                            containerClassName={styles['overlay-container']}
                            onClose={this.closeOrgChart}
                            isCloseButtonNeeded={false}
                            buttons={
                                [{
                                    text: getLabel('label_cancel_button'),
                                    onClick: () => this.clearSelectedActors(),
                                    className: styles['cancel-button']
                                }, {
                                    text: getLabel('label_add_button'),
                                    onClick: () => this.updateData(),
                                    className: styles['ok-button'],
                                    id: "tutorial-add-actor"
                                }]
                            }
                        >
                            <div className={styles.container}>
                                <OrgChart
                                    onOptionClick={this.onOptionClick}
                                    selectedActors={selectedActors}
                                    tempActorArray={tempActorArray}
                                    checkIfOptionPresentInArray={this.checkIfOptionPresentInArray}
                                    orgChart={this.props.orgChart}
                                    tutorial={this.props.tutorial}
                                    goToNextTutorialStep={this.goToNextTutorialStep}
                                    selfActor={this.props.selfActor}
                                />
                                <ClientOrgChart
                                    onOptionClick={this.onOptionClick}
                                    selectedActors={selectedActors}
                                    checkIfOptionPresentInArray={this.checkIfOptionPresentInArray}
                                    actors={this.props.actors}
                                    ref={(el) => {
                                        this.orgChartDiv = el;
                                    }}
                                />
                                {
                                    this.state.displayScrollInfo ?
                                        <div className={styles['scroll-text']}>
                                            {getLabel('label_scroll_org_chart_text')}
                                        </div>
                                        : null
                                }
                            </div>
                        </Dialog>
                        :
                        null
                }
            </Fragment>
        );
    }
}

ActorsHandler.propTypes = {};

ActorsHandler.defaultProps = {};

export default ActorsHandler;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/actorsHandler/ActorsHandler.js